import { render, staticRenderFns } from "./templateFooter.vue?vue&type=template&id=e8638ca0&scoped=true"
import script from "./templateFooter.vue?vue&type=script&lang=js"
export * from "./templateFooter.vue?vue&type=script&lang=js"
import style0 from "./templateFooter.vue?vue&type=style&index=0&id=e8638ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8638ca0",
  null
  
)

export default component.exports